import './TermsPage.css';

const TermsPage = () => {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <img src="/logo.png" alt="Logo" className="terms-logo" />
        <h1>Data Privacy Policy</h1>
        <p className="subtitle">Your privacy matters to us.</p>
      </div>

      <div className="terms-content">
        <p>
          We value your privacy. All information collected through this registration form will be treated with the highest
          level of confidentiality. Your data will be stored securely and will only be used for alumni profiling,
          communication, and academic-related services.
        </p>

        <h2>What We Collect</h2>
        <ul>
          <li>Personal identification (name, birthdate, contact info)</li>
          <li>Educational background</li>
          <li>Employment details (if applicable)</li>
          <li>Uploaded files (CV, photo, etc.)</li>
        </ul>

        <h2>How We Use Your Data</h2>
        <ul>
          <li>To verify and process alumni information</li>
          <li>To connect with alumni for events and updates</li>
          <li>To generate alumni statistics for institutional improvement</li>
        </ul>

        <h2>We Do NOT:</h2>
        <ul>
          <li>Sell or share your personal data with third parties</li>
          <li>Use your information for commercial gain</li>
        </ul>

        <p>
          By agreeing to the Terms and Conditions, you consent to the above policies. You can request data modification or
          deletion at any time by contacting the alumni office.
        </p>

        <p>Thank you for your trust.</p>
      </div>
    </div>
  );
};

export default TermsPage;
